import {
  call,
  select,
  all, put,
} from 'redux-saga/effects';

import { getDeliveryDetails } from 'features/order-tracker/api/orderTrackerApi';
import { INVALID_POSTCODE } from 'features/order-tracker/services/constants';
import { trackingEventsRequest } from './trackingEvents';
import {
  fetchDeliveryDetailsSucceed,
  setAPIFailed,
} from '../../actions';

import { getDeliveriesDetails, getDeliveryDetailsFailedMilestone } from '../services/helpers';
import { getState } from '../../selectors';

export function* deliveryDetailsRequest() {
  const {
    orderSummary: {
      postcode,
      ordersNumbers,
    },
  } = yield select(getState);

  try {
    const apiCalls = ordersNumbers.map(orderNumber => call(getDeliveryDetails, orderNumber, postcode));
    const responses = yield all(apiCalls);
    const deliveries: dto.OrderDeliveryDTO[] = responses.flat();
    const {
      totalDeliveryProducts,
      sentDeliveryProducts,
      deliveriesToTrack,
      isHybridConnectAvailable,
      smartHubProduct,
      orderMilestones,
    } = getDeliveriesDetails(deliveries, ordersNumbers);

    yield put(fetchDeliveryDetailsSucceed({
      deliveriesInfo: {
        totalDeliveryProducts,
        sentDeliveryProducts,
        isHybridConnectAvailable,
        smartHubProduct,
      },
    }));
    yield call(trackingEventsRequest, { orderMilestones, deliveriesToTrack });
  } catch (error) {
    const { message } = error as { message: string };
    const payload = message === INVALID_POSTCODE
      ? {
        isGeneralAPIFailed: true,
        isFetching: false,
        errorMessage: INVALID_POSTCODE,
      }
      : {
        deliveriesInfo: {},
        isDeliveryDetailsFailed: true,
        orderMilestones: [getDeliveryDetailsFailedMilestone()],
      };
    yield put(setAPIFailed(payload));

    console.error('Delivery Details Request:', message);
  }
}
